import { Container } from 'styled-bootstrap-grid';
import styled from 'styled-components';

export const SectionCTA = styled(Container)`
  margin-top: 20px;

  h2 {
    margin: 20px 0;
    line-height: 1;
  }

  text-align: center;
`;

export const ForgottenPasswordLink = styled.span`
  color: ${({ theme }) => theme.primaryColour};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.secondaryColour};
  }
`;
